<div class="csv-imports">
  @if (!data) {
  <div class="content">
    <qa-csv-import-upload-area
      [cancelUploadLabels]="cancelUploadLabels"
      [uploadAreaParameters]="uploadAreaParameters"
      isFlashImport="true"
      [title]="'common.label.importFlashcardFromTableExcelCSV' | translate"
      (cancelUpload)="onCancel($event)"
      (continueUpload)="onNext($event)"
    >
    </qa-csv-import-upload-area>
  </div>
  } @if (data) { @if (!showOverview) {
  <qa-content-spinner [active]="loading">
    @if (navigateForm) {
    <div class="flashcard-form-wrapper">
      <div>
        <ng-content *ngTemplateOutlet="main"></ng-content>
      </div>
    </div>
    }
  </qa-content-spinner>
  } @if (showOverview) {
  <div class="overview">
    <div class="csv-content">
      <mat-list>
        <mat-list-item class="list-item-header">
          <mat-checkbox
            class="check-all"
            color="primary"
            (change)="onSelectAll()"
            [checked]="!removedItemIdx.length"
            [ngClass]="{ 'selected-all': !removedItemIdx.length }"
          >
          </mat-checkbox>
          <div class="header-text">
            {{ 'question.table.text' | translate }}
          </div>
        </mat-list-item>

        <div
          class="question-list-wrapper"
          [style.height.px]="data?.csvData?.length * LIST_ITEM_HEIGHT"
        >
          <ng-scrollbar>
            @for (card of data?.csvData; track $index; let i = $index) {
            <mat-list-item class="question-list-items" (click)="editCard(i)">
              <mat-checkbox
                color="primary"
                (change)="onChange($event, i)"
                [checked]="!removedItemIdx.includes(i)"
                (click)="$event.stopPropagation()"
              >
              </mat-checkbox>
              <div class="item-position">
                {{ i + 1 }}
              </div>
              <div
                class="item-text"
                [ngClass]="{
                  success:
                    successFlashCard.includes(i) && !removedItemIdx.includes(i),
                  fail:
                    failedFlashCard.includes(i) && !removedItemIdx.includes(i)
                }"
              >
                <span> {{ card.text }}</span>
              </div>
            </mat-list-item>
            }
          </ng-scrollbar>
        </div>
      </mat-list>
    </div>
  </div>
  <div class="btn-action">
    <button
      color="primary"
      class="back-btn"
      [disabled]="isComplete"
      (click)="back()"
      mat-button
      type="button"
    >
      <mat-icon>arrow_back</mat-icon> {{ 'common.button.back' | translate }}
    </button>
    <div class="import-btn">
      <qa-button
        (submitted)="cancel()"
        [label]="isComplete ? 'common.button.done' : 'common.button.cancel'"
      ></qa-button>
      <qa-button
        [disabled]="
          isComplete ||
          inProgress ||
          removedItemIdx.length == data?.csvData?.length
        "
        [isRaisedButton]="true"
        (submitted)="importCsv()"
        data-cy="importAll"
        label="csvImports.importNow"
        type="submit"
      ></qa-button>
    </div>
  </div>
  }
  <ng-template #main>
    <qa-flash-card-edit
      #flashCardEdit
      [card]="data?.csvData[currentItemIndex]"
      (cardChange)="data.csvData[currentItemIndex] = $event"
      [isImport]="true"
      [importNavigation]="{
        count: data?.csvData?.length,
        index: currentItemIndex
      }"
      (importNavigate)="onNavigate($event)"
    >
      <div class="action-container" actionButtons>
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
    </qa-flash-card-edit>
  </ng-template>
  <ng-template #actions>
    <div class="action-buttons">
      <div class="accept">
        <mat-checkbox
          (change)="onChange($event)"
          (click)="$event.stopPropagation()"
          [(ngModel)]="isChecked"
          color="primary"
        >
        </mat-checkbox>
        <label>{{ 'common.label.accept' | translate }}</label>
      </div>
      <div class="flex-align-right d-flex">
        <qa-button
          class="mr-20"
          (submitted)="data = undefined"
          label="common.button.cancel"
        ></qa-button>
        <qa-button
          [isRaisedButton]="true"
          [disabled]="flashCardEdit?.form?.invalid"
          (submitted)="overviewData()"
          label="csvImports.toOverview"
        ></qa-button>
      </div>
    </div>
  </ng-template>
  }
</div>
